<app-full-screen-slider [active]="activeFullScreen"
                        [photo]="activePhoto"
                        [count]="activePhotos.length"
                        (activeEmit)="activeFullScreen = $event"
                        (clickLeftEmit)="nextPhoto()"
                        (clickRightEmit)="prevPhoto()"
/>
<div class="map-page-container">
    <div *ngIf="panorama" class="map-page-container-panorama-container">
        <app-panorama [panoramaKey]="panoramaKey" (close)="panoramaInactivate()"/>
    </div>
    <div class="map-container">
        <app-old-map [filterByTypes]="filter.filters ?? ['all']" (emitActive)="activate($event)" (emitPanorama)="panoramaActivate($event)" />
        <div *ngIf="activeInfo || activeFilter"  class="modal-info">
            <div *ngIf="activeInfo" class="info-container">
                <div (click)="activateInfo()" class="info-container-cross">
                    <app-icon [icon]="Icons.cross"/>
                </div>
                <div (click)="fullScreenSlider()" *ngIf="getImg()" class="info-container-photo">
                    <img [src]="getImg()" [alt]="getImg()"/>
                </div>
                <div class="info-container-text">
                    <div class="info-container-text-breadcrumbs">
                        {{ article.subTitle }}
                    </div>
                    <div class="info-container-text-title">
                        {{ article.title }}
                    </div>
                    <div class="info-container-text-paragraph">
                        {{ article.text }}
                    </div>
                </div>
                <div (click)="goToChronology()" class="button-container">
                    Изучить событие
                </div>
            </div>
            <div *ngIf="activeFilter" class="filter-container">
                <div (click)="goToChronology()" class="button-container">
                    Скрыть все события
                </div>
            </div>
        </div>
        <div class="zoom-container">
            <div (click)="oldMapComponent.zoomIn()" class="zoom-container-button zoom-container-button-plus">
                <app-icon [icon]="Icons.plus"/>
            </div>
            <div (click)="oldMapComponent.zoomOut()" class="zoom-container-button">
                <app-icon [icon]="Icons.minus"/>
            </div>
        </div>
    </div>
    <div class="map-settings">
        <app-searh-places [filter]="filter" (emitSearch)="search($event)" (emitActiveTypes)="filterByType($event)"/>
        <app-timeline (emitActive)="setActiveByTimeline($event)"/>
<!--        <div class="map-control">-->
<!--            <div class="col-3">-->
<!--                <div class="map-control-button" (click)="save()">Сохранить</div>-->
<!--                <div class="map-control-button" (click)="downloadJson()">Получить JSON</div>-->
<!--                <input style="display: none;"  type="file" #fileInput (change)="setJson($event)" accept=".json" />-->
<!--                <div class="map-control-button" (click)="triggerFileInput(fileInput)">Установить JSON</div>-->
<!--                <div class="map-control-button" (click)="reload()">Обновить</div>-->
<!--            </div>-->
<!--            <div class="col-3">-->
<!--                <div class="map-control-button" (click)="lineMode()">-->
<!--                    {{lineModeActive ?  'Закончить линию' : 'Нарисовать линию' }}-->
<!--                </div>-->
<!--                <div class="map-control-button" (click)="reload()">Обновить</div>-->
<!--                <div class="map-control-button" (click)="clear()">Очистить</div>-->
<!--                <div class="map-control-button" (click)="vailMap = !vailMap">-->
<!--                    {{vailMap ?  'Выключить карту' : 'Включить карту' }}-->
<!--                </div>-->

<!--            </div>-->
<!--            <div class="col-3"></div>-->
<!--            <div class="col-3">-->
<!--                <div class="map-control-button" (click)="setSpeed('plus')">+</div>-->
<!--                <div class="map-control-button" >Скорость перемещения: {{ mapService.getSpeed().toFixed(2) }}</div>-->
<!--                <div class="map-control-button" (click)="setSpeed('minus')">-</div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</div>
